/* Judge.me leaves a few screen-reader labels in English despite localized widgets. */
(() => {
  const locale = document.documentElement.lang.split('-')[0];
  if (locale !== 'fi' && locale !== 'fr') return;

  const widgetSelector = '#judgeme_product_reviews';
  const labelCopy = {
    fi: {
      sort: 'Lajittele arvostelut',
      average: (rating) => `Keskimääräinen arvosana ${rating}/5`,
      review: (stars) => `${stars} tähden arvostelu`,
      photo: (name, number) => `Arvostelukuva ${number}: ${name}`,
      photoAlt: (name) => `Arvostelukuva: ${name}`,
      verified: 'Shopin vahvistama',
    },
    fr: {
      average: (rating) => `Note moyenne de ${rating} sur 5`,
      review: (stars) => `Avis noté ${stars} étoile${stars === '1' ? '' : 's'}`,
      photo: (name, number) => `Photo ${number} de l’avis de ${name}`,
      photoAlt: (name) => `Photo de l’avis de ${name}`,
      verified: 'Vérifié par Shop',
    },
  }[locale];

  function localize() {
    const widget = document.querySelector(widgetSelector);
    if (!widget) return;

    if (labelCopy.sort) {
      widget.querySelectorAll('.jdgm-sort-dropdown-label').forEach((label) => {
        if (label.textContent.trim() === 'Sort by') label.textContent = labelCopy.sort;
      });
    }

    if (locale === 'fi') {
      const summary = widget.querySelector('.jdgm-rev-widg__summary-text');
      const count = /^Perustuu\s+([\d\s.,+]+)\s+arvosteluihin$/.exec(summary?.textContent.trim() || '');
      if (count) summary.textContent = `Perustuu ${count[1].trim()} arvosteluun`;
    }

    widget.querySelectorAll('[aria-label]').forEach((element) => {
      const current = element.getAttribute('aria-label');
      const average = /^Average rating is (\d+(?:\.\d+)?) stars?$/.exec(current);
      const review = /^(\d+) star review$/.exec(current);
      const photo = /^(.+) review photo (\d+)$/.exec(current);
      let localized;
      if (average) {
        localized = labelCopy.average(Number(average[1]).toLocaleString(locale, { maximumFractionDigits: 2 }));
      } else if (review) {
        localized = labelCopy.review(review[1]);
      } else if (photo) {
        localized = labelCopy.photo(photo[1], photo[2]);
      }
      if (localized) element.setAttribute('aria-label', localized);
    });

    widget.querySelectorAll('img[alt]').forEach((image) => {
      const current = image.getAttribute('alt');
      const photo = /^(.+) review photo$/.exec(current);
      if (current === 'Verified by Shop') image.setAttribute('alt', labelCopy.verified);
      else if (photo) image.setAttribute('alt', labelCopy.photoAlt(photo[1]));
    });
  }

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      localize();
    });
  });
  observer.observe(document.querySelector('#MainContent') || document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['aria-label', 'alt'],
  });
  localize();
})();
